<template>
    <h4>Transaction Lock Date</h4>
    <div class="form-check form-switch d-flex align-items-center gap-2 ps-0 mb-2">
        <label
            class="form-check-label"
            for="lock-transaction-date-switch"
        >
            Lock Transaction Date
        </label>
        <input
            v-model="lockTransactionDate"
            class="form-check-input m-0"
            type="checkbox"
            role="switch"
            id="lock-transaction-date-switch"
            @click="updateLockTransaction"
        />
    </div>
    <div class="mb-2">
        <label
            for="closing-date"
            class="form-label"
        >
            Closing Date
        </label>
        <input
            type="date"
            class="form-control width-20-per"
            id="closing-date"
            :disabled="!lockTransactionDate"
            v-model="closingDate"
            @change="handleClosingDateChange"
        >
    </div>
    <GlobalLoader />
</template>

<script setup>
import {inject, onMounted, ref} from "vue";
    import handleCompany from "@/services/modules/company";
    import GlobalLoader from "@/components/atom/GlobalLoader.vue";
    import {useStore} from "vuex";
    import {useRoute} from "vue-router";

    const lockTransactionDate = ref(false)
    const closingDate = ref(null)
    const { getCompanyPreferences, modifyCompanyPreference } = handleCompany();
    const $store = useStore();
    const $route = useRoute();
    const showSuccess =  inject('showSuccess');
    const companyId = $route.params.companyId;

    const updateLockTransaction = (e) => {
        const nextValue = e.target.checked; // ✅ new value after click

        const data = {
            company_id: companyId,
            field: "lock_transaction_date",
            value: nextValue,
        };

        handleUpdate(data);
    };

    const handleClosingDateChange = (e) => {
        const nextValue = e.target.value;

        const data = {
            company_id: companyId,
            field: "closing_date",
            value: nextValue,
        };

        handleUpdate(data);
    }

    const handleUpdate = (data) => {
        $store.state.loading = true;

        modifyCompanyPreference(data)
            .then((res) => {
                showSuccess(res.message);
            })
            .finally(() => ($store.state.loading = false));
    }

    const getInitialValue = (data, field) => {
        const item = data.find((item => item.field === field))

        return item ? item.value : null;
    }

    const parseBoolean = (v) => {
        if (typeof v === "boolean") return v;
        if (typeof v === "number") return v === 1;
        if (typeof v === "string") return v.trim() === "1";
        return false;
    }

    onMounted(() => {
        $store.state.loading = true

        const queryObject = {
            company_id: companyId,
            fields: 'lock_transaction_date,closing_date'
        }
        const query = '?' + new URLSearchParams(queryObject).toString();

        getCompanyPreferences(query)
            .then(res => {
                const data = res.data;
                lockTransactionDate.value = parseBoolean(getInitialValue(data, 'lock_transaction_date'));
                closingDate.value = getInitialValue(data, 'closing_date')
            })
            .finally(() => $store.state.loading = false);
    });
</script>